import InsuranceFeatures from './InsuranceFeatures';

export default InsuranceFeatures;
